import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { theme } from "../../Assets/Theme/theme";

function TimeSlots({ data }) {
  const priceCategories = data?.priceCategories || [];

  return (
    <Box sx={{ mt: 4 }}>
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table
          sx={{
            width: "100%",
            borderCollapse: "collapse",
          }}
          aria-label="price and time slots table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  borderBottom: "none",
                  padding: "10px 0",
                  color: theme.colors.text,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: theme.colors.text,
                  }}
                >
                  Price
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  borderBottom: "none",
                  padding: "10px 0",
                  color: theme.colors.text,
                }}
              >
                {/* <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: theme.colors.text,
                  }}
                >
                  Time Slots
                </Typography> */}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {priceCategories.length > 0 ? (
              priceCategories.map((category, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={{
                      borderBottom: "1px solid #ECECEC",
                      padding: "10px 0px",
                    }}
                  >
                    {category.prices.map((price, idx) => {
                      return (
                        <Typography
                          key={idx}
                          sx={{ display: "block", whiteSpace: "pre-line" }}
                          color={theme.colors.textLight}
                        >
                          {`${price.convertedsymbol}${price.convertsalePrice || price?.convertedPrice
                            }/ ${price.age?.name}`}
                        </Typography>
                      );
                    })}

                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: "1px solid #ECECEC",
                      padding: "10px 0px",
                      verticalAlign: "top",
                    }}
                  >
                    {/* <Typography
                      sx={{ color: theme.colors.textLight, fontWeight: 500 }}
                    >
                      {category.timeSlot}
                    </Typography> */}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={2}
                  sx={{
                    borderBottom: "1px solid #ECECEC",
                    padding: "10px 0px",
                  }}
                >
                  <Typography color={theme.colors.textLight}>
                    No time slots available.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default TimeSlots;
